import * as auditAreaTemplates from "./auditAreaTemplates";
import * as engagementTemplates from "./engagementTemplates";
import * as auditPlans from "./auditPlans";
import * as understandings from "./understandings";
import * as thirdParties from "./thirdParties";
import * as disclosureChecklistModels from "./disclosureChecklistModels";
import * as frameworks from "./frameworks";
import * as frameworkVersions from "./frameworkVersions";
import * as frameworkProfiles from "./frameworkProfiles";
import * as assessments from "./assessments";
import * as risks from "./risks";
import * as thirdPartyTiers from "./thirdPartyTiers";
import * as thirdPartyTags from "./thirdPartyTags";
import * as complexity from "./complexity";
import * as scopes from "./scopes";
import * as sources from "./sources";
import * as controls from "./controls";
import * as assessedControls from "./assessedControls";
import * as questionnaireModels from "./questionnaireModels";
import * as questionnaireTemplates from "./questionnaireTemplates";
import * as presetSchemas from "./presetSchemas";
import * as externalQuestionnaires from "./externalQuestionnaires";
import * as reportTemplates from "./reportTemplates";
import * as assets from "./assets";
import * as operationalContexts from "./operationalContexts";
import * as engagements from "./engagements";
import * as diagrams from "./diagrams";
import * as populations from "./populations";
import * as samples from "./samples";
import * as tests from "./tests";
import * as testTemplates from "./testTemplates";
import * as controlOe from "./controlOe";
import * as findings from "./findings";
import * as standardFindings from "./standardFindings";
import * as reviewerRoles from "./reviewerRoles";

const tprm = {
  auditAreaTemplates,
  engagementTemplates,
  auditPlans,
  understandings,
  thirdParties,
  thirdPartyTiers,
  thirdPartyTags,
  complexity,
  disclosureChecklistModels,
  frameworks,
  frameworkVersions,
  frameworkProfiles,
  assessments,
  risks,
  scopes,
  sources,
  controls,
  assessedControls,
  questionnaireModels,
  questionnaireTemplates,
  presetSchemas,
  externalQuestionnaires,
  reportTemplates,
  assets,
  operationalContexts,
  engagements,
  diagrams,
  populations,
  samples,
  tests,
  testTemplates,
  controlOe,
  findings,
  standardFindings,
  reviewerRoles,
};

export default tprm;
